import { JobRun } from '@/type';
import repository from './job-repository';

let jobIds: number[] = [];
let task: Promise<JobRun[]>|null = null;
function batchGetJobRuns(jobId: number): Promise<JobRun|null> {
  if (!jobIds.includes(jobId)) {
    jobIds.push(jobId);
  }
  if (!task) {
    task = new Promise((resolve) => {
      setTimeout(() => {
        task = null;

        if (jobIds.length === 0) {
          resolve([]);
          return;
        }
        const ids = [...jobIds];
        jobIds = [];
        repository.findRuns(ids)
          .then(resolve)
          .catch(() => {
            resolve([]);
          });
      }, 1500);
    });
  }
  return task.then((jobRuns) => {
    const jobRun = jobRuns.find(jr => jr.jobId === jobId);
    return jobRun || null;
  });
}

type OnJobRun = (jobRun: JobRun|null) => void;
export function ping(jobId: number, onStatus: OnJobRun): { (): void } {
  let timerId:ReturnType<typeof setTimeout>;
  let stopped = false;
  function fetch() {
    batchGetJobRuns(jobId).then((jobRun) => {
      // If stop() was called while we were fetching, just return.
      if (stopped) return;
      onStatus(jobRun);
      timerId = setTimeout(fetch, 5000);
    });
  }
  fetch();
  return () => {
    stopped = true;
    clearTimeout(timerId);
    jobIds = jobIds.filter(id => id !== jobId);
  };
}
